import { cn } from '@/src/lib/utils';
import { Popover, PopoverTrigger, PopoverContent } from './popover';
import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';
import { Calendar } from '@/src/shadComponents/ui/calendar';

export function DatePicker({ className, date, setDate }: any) {
    return (
        <div className={cn('grid gap-2', className)}>
            <Popover>
                <PopoverTrigger asChild>
                    <div
                        id="date"
                        className={cn(
                            'w-full justify-start flex items-center text-left border border-solid border-gray-700 dark:border-gray-100 rounded-lg text-black dark:text-white py-2 px-3 cursor-pointer',
                            !date && 'text-muted-foreground',
                        )}
                    >
                        <CalendarIcon className="mr-2 h-4 w-4 dark:filter-invert" />
                        {format(date, 'LLL dd, y')}
                    </div>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <div className="bg-white dark:bg-black z-50">
                        <Calendar
                            mode="single"
                            // @ts-ignore
                            initialFocus
                            defaultMonth={date}
                            selected={date}
                            // @ts-ignore
                            onSelect={setDate}
                            numberOfMonths={1}
                        />
                    </div>
                </PopoverContent>
            </Popover>
        </div>
    );
}
